// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Images
import bgImage from "assets/plus/home_bg.webp";

// Material-UI components
import { Box, Card, Grid, Typography } from "@mui/material";

// Icons
import { Payment } from "@mui/icons-material";

// React hooks
import { useEffect, useState } from "react";

// Controllers
import { getImageByType } from "controllers/ImagesController";

function Pagos() {
  const [promoImage, setPromoImage] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchPromoImage = async () => {
    try {
      const data = await getImageByType("pagos");
      if (Array.isArray(data)) {
        const image = data.find((img) => img.is_active === 1);
        setPromoImage(image);
      }
    } catch (error) {
      console.error("Error fetching promo image:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPromoImage();
  }, []);

  return (
    <>
      <MKBox bgColor="white">
        {/* Header Section */}
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: `linear-gradient(326deg, rgba(2,0,36,0.5) 0%, rgba(9,9,121,0.5) 35%, rgba(0,162,255,0.7) 100%), url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundBlendMode: "overlay",
            display: "grid",
            placeItems: "center",
          }}
        >
          <MKTypography
            variant="h1"
            color="white"
            sx={({ breakpoints, typography: { size } }) => ({
              [breakpoints.down("md")]: {
                fontSize: size["3xl"],
              },
            })}
          >
            Portal de Pagos
          </MKTypography>
        </MKBox>

        {/* Main Content */}
        <MKBox
          sx={{
            mx: { xs: 2, lg: 3 },
            mt: -6,
            mb: 4,
          }}
        >
          <Grid container spacing={3}>
            {/* Left Sidebar - Only Image (Hidden if no image) */}
            {!loading && promoImage && (
              <Grid item xs={12} lg={3}>
                <Card
                  sx={{
                    p: 3,
                    height: "fit-content",
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                      rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                  }}
                >
                  {/* Dynamic Promotional Image */}
                  <MKBox
                    component="img"
                    src={`data:image/webp;base64,${promoImage.file_data}`}
                    alt={promoImage.name || "Promo Pagos"}
                    width="100%"
                    borderRadius="lg"
                    shadow="md"
                  />
                </Card>
              </Grid>
            )}

            {/* Main Content - Iframe */}
            <Grid
              item
              xs={12}
              lg={!loading && promoImage ? 9 : 12} // Ocupa todo el ancho si no hay imagen
            >
              <Card
                sx={{
                  backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                    rgba(white.main, 0.8),
                  backdropFilter: "saturate(200%) blur(30px)",
                  boxShadow: ({ boxShadows: { xxl } }) => xxl,
                  overflow: "hidden",
                }}
              >
                {/* Iframe Header */}
                <Box
                  sx={{
                    p: 2,
                    backgroundColor: "tertiary.main",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Payment sx={{ mr: 1 }} />
                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                      Portal de Pagos PLUS
                    </Typography>
                  </Box>
                </Box>

                {/* Iframe Container */}
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    height: "70vh",
                    minHeight: "600px",
                  }}
                >
                  <iframe
                    src="https://pagos.iplus.com.ec/login"
                    title="Portal de Pagos PLUS"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      borderRadius: "0 0 8px 8px",
                    }}
                    allow="payment"
                    // sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
                  />
                </Box>

                {/* Footer Info */}
                <Box
                  sx={{
                    p: 2,
                    backgroundColor: "grey.50",
                    borderTop: "1px solid",
                    borderColor: "grey.200",
                  }}
                >
                  <Typography variant="body2" color="text.secondary" align="center">
                    <strong>PLUS Telecomunicaciones</strong> - Tu conexión a la velocidad del futuro
                  </Typography>
                </Box>
              </Card>
            </Grid>
          </Grid>
        </MKBox>
      </MKBox>
    </>
  );
}

export default Pagos;
